import { Input } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import Header from 'components/Header';
import { ReactComponent as SearchIcon } from 'assets/icons/searchIcon.svg';
import Nomails from './components/nomails';
import Inboxmails from './pages/inbox';
import Mailtimezone from './components/mailtimezone';
import Emailfeatures from './components/emailfeatures';
import Displayemail from './pages/displayemail';
import Composemail from './components/Composemail';
import Navigation from './pages/navigation';
import Filters from './components/filters';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-use';
import UseSearchMails from './hooks/useSearchMails';

import PrimaryButton from 'components/primaryButton';
import MailSkeleton from './components/MailSkeleton';

const Mail = () => {
  const [showcomposemodal, setShowcomposemodal] = useState(false);
  const [fechedMails, setMails] = useState([]);
  const [inboxMails, setInboxMails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState();
  const [searchTerm, setSearchterm] = useState('');
  const [searchedMails, setSearchedMails] = useState([]);
  const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 1000);
  const [date, setDate] = useState(new Date());
  const [mailFilter, setMailFilter] = useState('all');
  const [isLoading, setIsLoading] = useState(false);

  const [isUpdated, setIsUpdated] = useState(false);
  const [totalMails, settotalMails] = useState(0);
  const location = useLocation();
  let usesearchterm = UseSearchMails({ search: debouncedSearchTerm });

  const mailsCount = searchTerm //setting mails count
    ? searchedMails?.length || 0
    : location.pathname === '/app/mail/inbox'
    ? inboxMails?.length || 0
    : fechedMails?.length || 0;
  useEffect(() => {
    setSelectedEmail(null);
    setDate(new Date());
  }, [location, searchTerm]);
  const searchResults = usesearchterm?.data?.data;

  useEffect(() => {
    if (searchResults) {
      setSearchedMails(searchResults);
    }
  }, [searchResults]);
  // console.log('selected email:', selectedEmail);

  return (
    <div className='px-5'>
      <div className='flex justify-between items-center mb-6'>
        <div className='flex items-center gap-x-20 xl:gap-x-16 2xl:gap-x-16 3xl:gap-x-28 mt-6 ml-8 2xl:ml-12 3xl:ml-16'>
          <button
            onClick={() => setShowcomposemodal(!showcomposemodal)}
            className='2xl:w-40 2xl:text-lg 3xl:w-44 3xl:text-xl'
          >
            <PrimaryButton>+ Compose mail</PrimaryButton>
          </button>
          <Composemail
            opened={showcomposemodal}
            setOpened={setShowcomposemodal}
          />
          <Input
            value={searchTerm}
            icon={<SearchIcon />}
            //onChange={(e) => setSearchValue(e.target.value)}
            placeholder='Search'
            classNames={{
              wrapper: 'border-primary border-b',
              input: 'w-72 xl:w-60 2xl:w-80 3xl:w-96 bg-light-bg border-none',
            }}
            onChange={(e) => setSearchterm(e.target.value)}
          />
        </div>
        <div className='flex justify-end items-center mt-6'>
          <Header
            setInboxMails={setInboxMails}
            date={date}
            mailFilter={mailFilter}
            settotalMails={settotalMails}
            setIsLoading={setIsLoading}
          />
        </div>
      </div>

      <div className='gap-3 flex '>
        <div className='w-[30%]  relative shadow-three rounded-[6px] bg-FEFEFE h-[80vh] overflow-y-scroll scroller py-2 2xl:py-3 3xl:py-6'>
          <Navigation
            setMails={setMails}
            searchTerm={searchTerm}
            date={date}
            setIsLoading={setIsLoading}
          />
        </div>

        <div className='w-6/12 shadow-three rounded-2xl h-[80vh] overflow-y-scroll scroller p-3 2xl:py-4 3xl:py-6 bg-FEFEFE'>
          {
            // if no mails found then displaying skeleton
            isLoading ? (
              <div className='flex flex-col gap-y-4'>
                <MailSkeleton />
                <MailSkeleton />
                <MailSkeleton />
                <MailSkeleton />
              </div>
            ) : (
              <div className='flex flex-col relative bg-white '>
                <div
                  className={` fixed  bg-white z-10 w-[23%] -translate-y-3 `}
                >
                  <div className='bg-white h-[10px]'></div>
                  <Filters
                    mailFilter={mailFilter}
                    setMailFilter={setMailFilter}
                  />
                </div>
                <div className='h-8'></div>
                {
                  <Mailtimezone
                    day={searchTerm ? `Results for ${searchTerm}` : 'Today'}
                    curretmail={mailsCount}
                    totalmails={totalMails}
                    setDate={setDate}
                    date={date}
                    setIsUpdated={setIsUpdated}
                  />
                }
                <Inboxmails
                  date={date}
                  fechedMails={fechedMails}
                  inboxMails={inboxMails}
                  selectedEmail={selectedEmail}
                  setSelectedEmail={setSelectedEmail}
                  searchedMails={searchedMails}
                  searchTerm={searchTerm}
                  isUpdated={isUpdated}
                  setIsUpdated={setIsUpdated}
                />
              </div>
            )
          }
        </div>

        <div className='w-full shadow-three relative rounded-tr-2xl h-[80vh] overflow-y-scroll scroller px-3 py-4 bg-FEFEFE 2xl:px-4 2xl:py-5 3xl:px-6 3xl:py-6'>
          {!selectedEmail ? (
            <Nomails />
          ) : (
            <div className='flex flex-col justify-start w-full h-full relative'>
              <Emailfeatures selectedEmail={selectedEmail} />
              <div className='bg-F8F7F7 min-h-[65vh] xl:min-h-[65vh] 2xl:minh-[67vh] 3xl:min-h-[69vh] pt-14'>
                <Displayemail
                  data={selectedEmail}
                  setIsUpdated={setIsUpdated}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Mail;
